module.exports = __webpack_public_path__ + "static/media/bets.e041932d.svg";